// CriticalParameters.js
import React, { useEffect, useState } from 'react';
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  makeStyles,
  Typography,
} from '@material-ui/core';
import { presentFormatedData } from '../../../../functionalComponents/dataFormatFunctions';

const useStyles = makeStyles((theme) => ({
    fieldLabel: {
        fontWeight: 'bold',
        marginBottom: theme.spacing(1),
        },
  table: {
    minWidth: 650,
  },
  tableCell: {
    fontWeight: 600,
  },
  buttonGroup: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-start',
    gap: theme.spacing(2),
  },
  addButton: {
    textTransform: 'none',
    borderRadius: '20px',
    width: '180px',
  },
  saveButton: {
    backgroundColor: '#f06543',
    color: '#fff',
    textTransform: 'none',
    borderRadius: '20px',
    width: '180px',
    '&:hover': {
      backgroundColor: '#d35430',
    },
  },
}));

const ViewCriticalParameters = (props) => {
    const classes = useStyles();
    const { parameters ,sample } = props;

  // Updated rows structure according to the new format
  const [rows, setRows] = useState(parameters ? parameters: []);

    useEffect(() => {
        setRows(parameters ? parameters: [])
    },[parameters])

//   const handleAddNewRecord = () => {
//     setRows([...rows, { parameter: '', upperLimit: '', lowerLimit: '', value: '', uom: '' }]);
//   };

//   const handleSaveChanges = () => {
//     // Handle the save action here
//     console.log('Saved rows:', rows);
//   };

  return (
    <Container>
      <Typography className={classes.fieldLabel}>{sample ? 'Critical Quality Attributes':'Critical Parameters' }</Typography>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="critical parameters table">
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableCell} align='left'>Parameter</TableCell>
              <TableCell className={classes.tableCell} align='left'>Range</TableCell>
              <TableCell className={classes.tableCell} align='right'>{sample ? 'Value':'Value (Time Averaged)'}</TableCell>
              <TableCell className={classes.tableCell} align='left'>{sample ? 'Unit' : 'Unit of Measure (UOM)'}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={index}>
                <TableCell align='left'>{presentFormatedData(row.parameter)}</TableCell>
                <TableCell align='left'>{sample ? presentFormatedData(row.lowerLimit) : presentFormatedData(row.LowerLimit)} to {presentFormatedData(row.upperLimit)}</TableCell>
                <TableCell align='right'>{presentFormatedData(row.value)}</TableCell>
                <TableCell align='left'>{presentFormatedData(row.uom)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

    </Container>
  );
};

export default ViewCriticalParameters;
